import { ProjectBudget, ProjectData } from '../types/types';
import { apiResource } from '../../../common/services/apiClient';
import { getApiBaseUrl } from 'common/services/apiBaseUrl';

const baseApi = apiResource<ProjectData>('projects');

const apiBaseUrl = getApiBaseUrl();
export const API_URL = apiBaseUrl + '/v2';
import apiFetch from 'common/services/apiFetch';

async function request<T>(
	url: string,
	method: string,
	token: string,
	body?: Partial<T>
): Promise<T> {
	const res = await apiFetch(`${API_URL}${url}`, {
		method,
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
		body: body ? JSON.stringify(body) : undefined,
	});
	if (!res.ok) throw new Error(`Failed to ${method} ${url}`);
	return method === 'DELETE' ? (undefined as unknown as T) : res.json();
}

const baseUrl = `/projects`;

export const projectsApi = {
	...baseApi, // CRUD générique

	getOneByQuote: (token: string, quoteId: string) =>
		request<ProjectData | null>(`${baseUrl}/by-quote/${quoteId}`, 'GET', token),

	budget: (id: number, token: string) =>
		request<ProjectBudget>(`${baseUrl}/${id}/budget`, 'GET', token),
};
